// extracted by mini-css-extract-plugin
module.exports = {"container":"LeisureCommonBadges_container__26Y4q","hotdeal":"LeisureCommonBadges_hotdeal__16PCx","badge":"LeisureCommonBadges_badge__3_xxA"};